/* lua.js generated code 0.3.0 */

kErrorCodeRange = 760000
ZooErrorCode = table.const(table(
    [1, "kDefaultError", -1],
    [1, "kNetworkError", -2],
    [1, "kTimeoutError", -3],
    [1, "kServerError", -4],
    [1, "kInvalidParams", -5],
    [1, "kNotLoginError", -6],
    [1, "kServiceUnavailable", -7],
    [1, "kHeaderSumError", 104],
    [1, "kSessionKeyInvalid", 108],
    [1, "kUserBanned", 109],
    [1, "kUniKeyInvalid", 110],
    [1, "kAbandonWithErrorBefore", 203],
    [1, "kUnknownServerError", 206],
    [1, "kPaymentLoginFailure", 213 + kErrorCodeRange],
    [1, "INVALID_SESSION_KEY", 206 + kErrorCodeRange],
    [1, "CONFIG_ERROR", 209 + kErrorCodeRange],
    [1, "PROP_NOT_ENOUGH", 311 + kErrorCodeRange],
    [1, "ADD_PROP_MODE_ERROR_START_LEVEL", 313 + kErrorCodeRange],
    [1, "STAGE_INFO_NOT_EXIST", 314 + kErrorCodeRange],
    [1, "USE_PROP_RANGE_ERROR", 315 + kErrorCodeRange],
    [1, "USE_PROP_LEVEL_ERROR", 316 + kErrorCodeRange],
    [1, "USE_ENERY_PLUS_PROP_ERROR", 318 + kErrorCodeRange],
    [1, "USE_ENERY_PLUS_PROP_ERROR_ENERGY_PLUS_ERROR", 319 + kErrorCodeRange],
    [1, "COIN_NOT_ENOUGH", 321 + kErrorCodeRange],
    [1, "EXP_NOT_ENOUGH", 322 + kErrorCodeRange],
    [1, "POINT_NOT_ENOUGH", 325 + kErrorCodeRange],
    [1, "ENERGY_NOT_ENOUGH", 326 + kErrorCodeRange],
    [1, "CASH_NOT_ENOUGH", 330 + kErrorCodeRange],
    [1, "BUY_LEVEL_NOT_ENOUGH", 390 + kErrorCodeRange],
    [1, "BUY_WRONG_MONEY_TYPE", 393 + kErrorCodeRange],
    [1, "BUY_GOOODSID_INVAILD", 400 + kErrorCodeRange],
    [1, "BUY_LIMIT_GOODS_ERROR_OVER_LIMIT", 402 + kErrorCodeRange],
    [1, "BUY_ECPSS_GOODS_ERROR", 404 + kErrorCodeRange],
    [1, "ITEM_TYPE_NOT_SUPPORT", 470 + kErrorCodeRange],
    [1, "ACTIVITY_IS_EXPIRED", 580 + kErrorCodeRange],
    [1, "LEVEL_ID_INVALID", 601 + kErrorCodeRange],
    [1, "LEVEL_ID_INVALID_START_LEVEL", 602 + kErrorCodeRange],
    [1, "INVALID_REQUEST_TIME", 603 + kErrorCodeRange],
    [1, "UNDEFINED_LEVEL_TYPE", 604 + kErrorCodeRange],
    [1, "FUNC_NOT_ENOUGH", 611 + kErrorCodeRange],
    [1, "DECO_NOT_ENOUGH", 621 + kErrorCodeRange],
    [1, "UNLOCK_LEVEL_ID_NOT_MATCH", 661 + kErrorCodeRange],
    [1, "INVITE_REWARD_NOT_AVAILABLE", 671 + kErrorCodeRange],
    [1, "INVITE_REWARD_ALREADY_GET", 672 + kErrorCodeRange],
    [1, "HIDE_AREA_ERROR_AREA_UNLOCK", 701 + kErrorCodeRange],
    [1, "DIGGER_MATCH_ERROR_REACH_MAX_COUNT_ERROR", 734 + kErrorCodeRange],
    [1, "SHAKE_NO_TIMES", 2001 + kErrorCodeRange],
    [1, "WEEK_MATCH_ERROR_MATCH_NOT_AVAILABLE", 773 + kErrorCodeRange],
    [1, "WEEK_MATCH_ERROR_LEVEL_INVALID", 774 + kErrorCodeRange],
    [1, "WEEK_MATCH_ERROR_DAILY_LIMIT", 775 + kErrorCodeRange],
    [1, "REWARD_REPEAT", 1032 + kErrorCodeRange],
    [1, "ACTIVITY_DATA_ERROR", 1035 + kErrorCodeRange],
    [1, "TEAM_GET_STAR_ALREADY_IN_OTHER_TEAM", 2260 + kErrorCodeRange],
    [1, "TEAM_GET_STAR_JOIN_SELF", 2261 + kErrorCodeRange],
    [1, "TEAM_GET_STAR_LEVEL_NOT_MATCH", 2262 + kErrorCodeRange],
    [1, "NEW_TEAM_GET_STAR_NOT_LEADER", 2268 + kErrorCodeRange],
    [1, "TEAM_GET_STAR_MEMBER_NOT_EXISTS", 2270 + kErrorCodeRange],
    [1, "REFRESH_STAR_NEXT_LEVEL_ERR", 2272 + kErrorCodeRange],
    [1, "REFRESH_STAR_TEAM_REQ_LEVEL", 2273 + kErrorCodeRange],
    [1, "REFRESH_STAR_TEAM_EVER_MEMBER", 2275 + kErrorCodeRange],
    [1, "USE_PROP_OVER_LIMIT_IN_GAME", -201],
    [1, "VERSION_UNSUPPORT", -202],
    [1, "CURRENT_IS_RUNNING", -203],
    [1, "NO_UPDATE_DATA", -204],
    [1, "BUY_PRODUCTID_INVALID", -205],
    [1, "HIDE_LEVEL_UNLOCK", -206],
    [1, "HIDE_LEVEL_PASSED", -207],
    [1, "META_NOT_FOUND", -208],
    [1, "REACH_MAX_LEVEL", -209],
    [1, "UNLOCK_STAR_NOT_ENOUGH", -210],
    [1, "UNLOCK_TIME_NOT_ENOUGH", -211],
    [1, "UNLOCK_FRIEND_NOT_ENOUGH", -212],
    [1, "UNLOCK_REQUEST_NO_FRIEND", -213],
    [1, "UNLOCK_SERER_REJECT", -214],
    [1, "MARK_FAILED", -215],
    [1, "UNLOCK_CONDITION_NOT_MATCH", -216],
    [1, "USE_PRE_PROP_NOT_PASS_LEVEL", -217],
    [1, "PAY_TYPE_UNSUPPORT", -218],
    [1, "PAY_EXCEED_DAILY_LIMIT", -219],
    [1, "PAY_EXCEED_MONTHLY_LIMIT", -220],
    [1, "VERIFIED_FAILED", -221],
    [1, "WEEK_GAME_NEED_PLAY_TO_ADD_COUNT", -222],
    [1, "WEEK_GAME_NEED_SHARE_OR_BUY_TO_ADD_COUNT", -223],
    [1, "WEEK_GAME_NEED_BUY_TO_ADD_COUNT", -224],
    [1, "NEW_TEAM_GET_STAR_CREATE_TEAM_LEVEL", -225],
    [1, "NEW_TEAM_GET_STAR_TEAM_NOT_EXISTS", -226],
    [1, "NEW_TEAM_GET_STAR_TEAM_NAME_INVALID", -227],
    [1, "NEW_TEAM_GET_STAR_TEAM_NAME_TOO_LONG", -228],
    [1, "NEW_TEAM_GET_STAR_INVALID_INVITE_CODE", -229],
    [1, "NEW_TEAM_GET_STAR_REPEAT_JOIN_TEAM", -230],
    [1, "NEW_TEAM_GET_STAR_NO_AVAILABLE_REWARD", -231],
    [1, "NEW_TEAM_GET_STAR_REWARD_REMAIN", -232],

    [1, "WANTED_TIMES_NOT_AVAILABLE", 2276 + kErrorCodeRange],

    [1, "NOT_PASS_TAGRET_MIAN_LEVEL", 2278 + kErrorCodeRange],
    [1, "NOT_PASS_All_TAGRET_HIDE_LEVEL", 2279 + kErrorCodeRange],
    [1, "WANTED_ITEM_TIMEOUT", 704 + kErrorCodeRange],
    [1, "WANTED_REMAIN_TAKE_NUM", 287 + kErrorCodeRange],
    [1, "WANTED_REMAIN_CANCEL_NUM", 705 + kErrorCodeRange],
    [1, "WANTED_TASK_ALREADLY_TAKED", 706 + kErrorCodeRange],
    [1, "WANTED_PUBLISH_TASK_TIMES_NOT_ENOUGH", 707 + kErrorCodeRange],
    [1, "WANTED_TASK_ENDED", 304 + kErrorCodeRange],

    [1, "TIME_MODE_ACTIVITY_END", 1630 + kErrorCodeRange],
    [1, "TIME_MODE_TIME_NOT_ENOUGT", 1635 + kErrorCodeRange],

    [1, "Mark_CANT_REMARK", 1862 + kErrorCodeRange],

    [1, "COIN_MATCH_STEP_NOT_ENOUGT", 3300 + kErrorCodeRange],
    [1, "COIN_MATCH_STEP_MAY_NOT_ENOUGT", 3301 + kErrorCodeRange],

    [1, "VIP_MONTH_INVALID", 334 + kErrorCodeRange]
))
